import { render } from "./ChooseImage.vue?vue&type=template&id=884b54f8&scoped=true"
import script from "./ChooseImage.vue?vue&type=script&lang=js"
export * from "./ChooseImage.vue?vue&type=script&lang=js"

import "./ChooseImage.vue?vue&type=style&index=0&id=884b54f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-884b54f8"
/* hot reload */
if (module.hot) {
  script.__hmrId = "884b54f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('884b54f8', script)) {
    api.reload('884b54f8', script)
  }
  
  module.hot.accept("./ChooseImage.vue?vue&type=template&id=884b54f8&scoped=true", () => {
    api.rerender('884b54f8', render)
  })

}

script.__file = "src/components/ChooseImage.vue"

export default script